import z from "zod";

import { ColorIconSchema } from "./common.schema";

export const TitleIconSettingsSchema = z.object({
  id: z.number().int().positive(),
  position: z.number().int().positive(),
  icon: ColorIconSchema,
});

export const TitleWithIconSchema = z.object({
  id: z.number().int().positive(),
  text: z.string().min(1),
  titleIconSettings: z.preprocess(
    (val) => (val == null ? [] : val),
    z.array(TitleIconSettingsSchema),
  ),
});
